<template>
  <div class="email">
    <div>
      <div class="subtitle">Ваш email</div>

      <v-text-field
        class="email_input"
        v-model="data_local.recipient_email"
        type="email"
        placeholder="user@example.com"
        hint="Почта на которую будут приходить уведомления"
        persistent-hint
        outlined
        dense
        @input="input"
      />

      <div class="subtitle">Тема письма</div>
      <v-text-field
        v-model="data_local.email_subject"
        placeholder="Тема письма"
        outlined
        dense
        @input="input"
      />

      <h3 class="subtitle">Текст письма</h3>
      <v-textarea
        class="my_textarea"
        auto-grow
        v-model="data_local.sms_text"
        placeholder="Введите текст или HTML письма"
        outlined
        @input="input"
      />
      <div class="paste" @click="pasteVariable('phone')">Номер клиента</div>
      <div class="paste" @click="pasteVariable('phoneA')">Номер звонка</div>
      <div class="paste" @click="pasteVariable('target')">Цели</div>
      <div class="paste" @click="pasteVariable('answer')">Ответ клиента</div>
      <div class="paste" @click="pasteVariable('record')">Запись звонка</div>
      <div class="paste" @click="pasteVariable('callname')">
        Название обзвона
      </div>
      <div class="paste" @click="pasteVariable('script')">
        Название сценария
      </div>
      <div class="paste" @click="pasteVariable('base')">Название базы</div>
      <div class="row">
        <div class="num_symbols">
          Символов: {{ (data_local.sms_text || '').length }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data', 'edit_callback'],

  data() {
    return {
      defaultEmailApplied: false,

      data_local: {
        message_channel: 'email',
        email_notification: true,
        recipient_email: '',
        email_subject: '',
        sms_text: '',
        type: 0,
        phone: '',
      },
    };
  },

  watch: {
    data: {
      immediate: true,

      handler(val) {
        this.data_local = {
          ...this.data_local,
          ...(val || {}),
          message_channel: 'email',
          email_notification: true,
        };

        if (!this.defaultEmailApplied) {
          this.defaultEmailApplied = true;

          const accountEmail = this.$store.getters['user/getEmail'];

          if (
            !String(this.data_local.recipient_email || '').trim() &&
            accountEmail
          ) {
            this.data_local.recipient_email = accountEmail;
            this.input();
          }
        }
      },
    },
  },

  methods: {
    pasteVariable(name) {
      this.data_local.sms_text =
        String(this.data_local.sms_text || '') + `{${name}}`;

      this.input();
    },

    input() {
      this.edit_callback(this.data_local);
      return true;
    },
  },
};
</script>

<style scoped>
.email {
  max-width: 600px;
  width: 600px;
  margin: 32px auto 0 auto;
}

.email_alert {
  background-color: #fffbea;
  color: #ffb74d;
  padding: 10px 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  text-align: center;
}

.subtitle {
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 120%;
  color: #404247;
  text-align: left;
  margin: 14px 0 6px;
}

.my_textarea {
  margin-top: 8px;
}

.row {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 12px 0 0 0 !important;
}

.num_symbols {
  color: #777;
  font-size: 13px;
}
.paste {
  padding: 9px 20px 10px;
  background: #ffffff;
  display: inline-block;
  border: 1px solid #4b5eff;
  border-radius: 8px;
  margin: 12px 0 0 10px;
  cursor: pointer;
  font-weight: 600;
  font-size: 15px;
  line-height: 110%;
  color: #2b2d33;
}
.email_input ::v-deep .v-text-field__details {
  min-height: 18px;
  margin-top: 5px;
  padding: 0 4px;
}

.email_input ::v-deep .v-messages__message {
  color: #8b8e9b;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0;
}
</style>
